"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = EditableContextMenu;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var DEFAULT_PROPS = {
  components: {
    contextMenu: function contextMenu(_ref) {
      var children = _ref.children,
          handleClose = _ref.handleClose,
          menuPosition = _ref.menuPosition;

      var style = _objectSpread({
        border: '1px solid gray',
        borderRadius: '0.2em',
        padding: '0.25em',
        background: 'white',
        position: 'fixed'
      }, menuPosition);

      return /*#__PURE__*/_react.default.createElement("div", {
        className: "contextMenu",
        style: style,
        onClose: handleClose
      }, children);
    },
    contextMenuItem: function contextMenuItem(_ref2) {
      var action = _ref2.action,
          index = _ref2.index,
          disabled = _ref2.disabled,
          selection = _ref2.selection,
          element = _ref2.element,
          type = _ref2.type,
          subtype = _ref2.subtype;
      var style = {
        padding: '0.25em',
        color: disabled ? 'grey' : 'inherit'
      };
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "menuItem",
        style: style,
        "data-test-id": "contextMenuItem-".concat(index),
        onClick: action.callback
      }, action.label);
    }
  },
  actions: [{
    label: 'Paragraph',
    type: 'block',
    subtype: 'p'
  }, {
    label: 'Block Quote',
    type: 'block',
    subtype: 'q'
  }, {
    label: 'Block Quote 2',
    type: 'block',
    subtype: 'q2'
  }, {
    label: 'Block Quote 3',
    type: 'block',
    subtype: 'q3'
  }, {
    label: 'Descriptive Subtitle',
    type: 'block',
    subtype: 'd'
  }, {
    label: 'Major Title',
    type: 'block',
    subtype: 'mt'
  }, {
    label: 'Major Title 2',
    type: 'block',
    subtype: 'mt2'
  }, {
    label: 'Major Title 3',
    type: 'block',
    subtype: 'mt3'
  }, {
    label: 'Chapter',
    type: 'chapter'
  }, {
    label: 'Verse',
    type: 'verses'
  }]
};

function EditableContextMenu(_ref3) {
  var _components = _ref3.components,
      save = _ref3.save,
      children = _ref3.children;
  var defaultState = (0, _react.useMemo)(function () {
    return {
      menuPosition: undefined,
      selection: undefined,
      element: undefined,
      type: undefined,
      subtype: undefined
    };
  }, []);

  var _useState = (0, _react.useState)(defaultState),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var open = !!state.menuPosition;

  var actions = _toConsumableArray(DEFAULT_PROPS.actions);

  var components = _objectSpread(_objectSpread({}, DEFAULT_PROPS.components), {}, {
    _components: _components
  });

  var ContextMenu = components.contextMenu,
      ContextMenuItem = components.contextMenuItem;

  var handleContextMenu = function handleContextMenu(event) {
    var element = event.target;
    var type = element.dataset.type;
    var subtype = element.dataset.subtype;
    if (type === 'block') event.preventDefault();
    var x = event.clientX,
        y = event.clientY;
    var menuPosition = !state.menuPosition ? {
      top: y,
      left: x
    } : undefined;
    var selection = document.getSelection();
    setState({
      menuPosition: menuPosition,
      selection: selection,
      element: element,
      type: type,
      subtype: subtype
    });
  };

  var handleClose = (0, _react.useCallback)(function (event) {
    event.preventDefault();
    setState(defaultState);
  }, [defaultState]);
  (0, _react.useEffect)(function () {
    if (open) document.addEventListener("click", handleClose);
    return function () {
      document.removeEventListener("click", handleClose);
    };
  }, [open, handleClose]);
  var availableActions = actions.filter(function (action) {
    return action.type === state.type;
  });
  var contextMenuItems = [];

  if (open) {
    contextMenuItems = availableActions.map(function (action, index) {
      var disabled = action.subtype === state.subtype;
      var element = state.element,
          selection = state.selection,
          type = state.type,
          subtype = state.subtype;

      if (!action.callback && type && subtype) {
        action.callback = function () {
          element.classList.remove(element.dataset.subtype);
          element.dataset.subtype = action.subtype;
          element.classList.add(action.subtype);

          var _element = element.closest('div[contenteditable]');

          save(_element);
        };
      }

      if (disabled) action.callback = function () {};
      return /*#__PURE__*/_react.default.createElement(ContextMenuItem, _extends({
        key: "".concat(action.type, ":").concat(action.subtype),
        index: index,
        disabled: disabled,
        action: action
      }, state));
    });
  }

  ;
  var contextMenuProps = {
    open: open,
    menuPosition: state.menuPosition,
    handleClose: handleClose
  };

  var contextMenu = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);

  if (open && availableActions.length > 0) {
    contextMenu = /*#__PURE__*/_react.default.createElement(ContextMenu, contextMenuProps, contextMenuItems);
  }

  ;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "contextMenuWrapper",
    onContextMenu: handleContextMenu,
    style: {}
  }, children, contextMenu);
}

;
EditableContextMenu.propTypes = {
  /** Components to wrap all sections of the document */
  components: _propTypes.default.shape({
    /** Component to render the contextMenu */
    contextMenu: _propTypes.default.func,

    /** Component to render the contextMenuItems */
    contextMenuItem: _propTypes.default.func
  }),
  save: _propTypes.default.func.isRequired,
  children: _propTypes.default.any.isRequired
};
EditableContextMenu.defaultProps = DEFAULT_PROPS;